export default "__VITE_ASSET__uUfThxfj__"